import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: theme.spacing(0, 1),
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'space-between',
    columnGap: '1em',
  },
  cardInput: {
    '&.Mui-error': {
      border: '1px solid #FF0000',
    },
    height: '32px',
  },
  error: {
    fontSize: '13px',
  },
  cardForm: {
    margin: theme.spacing(0, 0, 1),
    width: '85%',
  },
  cardText: {
    color: theme.palette.grey.dark,
    fontSize: '12px',
    margin: theme.spacing(0, 0, .5),
    fontWeight: 600
  },
  submitButton: {
    height: '32px',
  },
  link: {
    color: '#fff',
  },
  paymentModalInner: {
    textAlign: 'center',
    display: 'flex',
    flexFlow: 'column',
    rowGap: '0.5rem',
    height: '100%',
  },
  paymentModalBrandImg: {
    maxHeight: '40px',
  },
  frameBlock: {
      width: '100%',
      height: '100%',
      margin: '0 auto',
      overflow: 'auto',
  },
  formControl: {
    width: '100%'
  },
  icon: {
    height: '16px',
  }
}));

export default useStyles;
